import React from 'react';
import { PropertyAttribute } from './PropertyAttribute';
import { Info } from '../CellTypes';
import { PropertyAttributes } from '../../../../../Interface/Response/Interest/PropertyAttributes';

const PropertyAttributesCell: React.FC<PropertyAttributes> = props => {
    const { remark, info, infoExpanded, viisiNote, label, property, upcomingChange } = props;

    return (
        <div className="property-property__cell">
            <div>
                <PropertyAttribute {...props} />
            </div>
            {(info !== undefined || viisiNote !== undefined || upcomingChange !== undefined) && (
                <Info
                    expanded={infoExpanded}
                    info={info}
                    viisiNote={viisiNote}
                    label={label}
                    property={property}
                    upcomingChange={upcomingChange}
                />
            )}
            {remark !== undefined && <div className="property-property__cell__remark">{remark}</div>}
        </div>
    );
}

export default PropertyAttributesCell;
